window.FormaPagamentoView = Backbone.Marionette.CompositeView.extend({
    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
    }
});